module.exports = __webpack_public_path__ + "static/media/fruit-orange-0.3dd93330.png";